import TextArea from './TextArea';

export type { TextAreaProps } from './TextArea';

export default TextArea;
